"use client";

import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getActivities } from "@/actions/activity";
import type { ActivityDefinition } from "@/lib/activities";

export const ACTIVITIES_QUERY_KEY = ["activities"] as const;

export function useActivities() {
  return useQuery<ActivityDefinition[]>({
    queryKey: ACTIVITIES_QUERY_KEY,
    queryFn: async () => {
      const result = await getActivities();
      if (!result.ok) {
        throw new Error(result.message ?? "Unable to load activities");
      }
      return result.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useActivityCatalog() {
  const query = useActivities();
  const dictionary = useMemo(() => {
    if (!query.data) {
      return new Map<string, ActivityDefinition>();
    }

    return new Map(
      query.data.map((activity) => [activity.id, activity] as const),
    );
  }, [query.data]);

  return { ...query, dictionary };
}
